import type { RadioGroupProps, RadioProps } from "antd";
import { Radio } from "antd";
import type { ComponentType, FC, ReactNode } from "react";
import LabelAndValueUntyped from "../../form/LabelAndValue";

const LabelAndValue = LabelAndValueUntyped as ComponentType<{
    label?: ReactNode;
    children?: ReactNode;
}>;

export interface HRadioCardOption {
    value: string;
    label?: string;
    tag?: string;
    dataCy?: string;
}

export interface HRadioCardGroupProps {
    options?: HRadioCardOption[];
    groupLabel?: ReactNode;
    radioGroupProps?: RadioGroupProps;
    radioProps?: RadioProps;
}


const HRadioCardGroup: FC<HRadioCardGroupProps> = ({
    options,
    groupLabel,
    radioGroupProps,
    radioProps,
}) => {
    const mergedRadioGroupProps: RadioGroupProps = {
        ...radioGroupProps,
        className: ["hs-radio-card-group w-100 d-flex flex-column gap-3", radioGroupProps?.className]
            .filter(Boolean)
            .join(" "),
    };

    return (
        <LabelAndValue label={groupLabel}>
            <Radio.Group {...mergedRadioGroupProps}>
                {options?.map((option) => {
                    const key = option.value ?? "";
                    return (
                        <Radio
                            key={key}
                            {...radioProps}
                            value={option.value}
                            className={["hs-radio-card-option w-100", radioProps?.className].filter(Boolean).join(" ")}
                            data-cy={option.dataCy}
                        >
                            <div className="d-flex flex-column align-items-start text-start ps-1">
                                <span className="hs-fw-600 hs-fs-14 hs-color-BlackRussian">
                                    {option.label || option.value}
                                </span>
                                {option.tag ? (
                                    <span className="hs-fs-12 hs-color-mediumDark mt-1">{option.tag}</span>
                                ) : null}
                            </div>
                        </Radio>
                    );
                })}
            </Radio.Group>
        </LabelAndValue>
    );
};

export default HRadioCardGroup;
